import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPostsRoot } from 'redux/selectors';
import Activities from './components/Activities';

export default function ActivityFeed({ routeRoot } = {}) {
	const root = useSelector(getPostsRoot) || 'lifebooks';
	const activeRouteRoot = routeRoot || root;

	return (
		<Switch>
			<Route
				path={`/${activeRouteRoot}/:feedType(activity|profileActivity|exportActivity)/:childId`}>
				<Activities root={activeRouteRoot} />
			</Route>
		</Switch>
	);
}
